goog.provide('el8.uiwidget.FeedPage');

//=============================================================
// FeedPage
//
//   This is a helper model for modeling the notion of a 
//   "page" displayed within a feed. A feed has an entire 
//   index and at a given point in time it may only be 
//   displaying a subset of that index, which we can represent 
//   with a "page", or "FeedPage". Is pretty simple - has two 
//   main attributes:
//     - "start" - index position corresponding to start of page
//     - "size" - number of items in page
//=============================================================

el8.uiwidget.FeedPage = function(start, size) {

    /* Basic getting and setting of stat and size */
    this.setStart = function(start) { this._start = start*1 || 0; };
    this.setSize = function(size) { this._size = size*1 || 0; };
    this.getStart = function() { return this._start; };
    this.getSize = function() { return this._size; };
    this.set = function(start, size) {
        this.setStart(start);
        this.setSize(size);
        // Stop gaps to deny negative numbers, which should never happen
        if (this._start < 0) { UIM && UIM.logError('Hmm page has negative start value'); }
        if (this._size < 0) { UIM && UIM.logError('Hmm page has negative size'); }
    };

    /* Initialize */
    this.set(start, size);

    /* getEnd is index of last item + 1 */
    this.getEnd = function() { return this._start + this._size; };

    /* Grow and Shrink page */
    this.shrinkByOne = function(includeFirstItem) { 
        if (includeFirstItem) { this._start += 1; }
        this._size -= 1;
    };
    this.grow = function(amount, includeFirstItem) { 
        if (amount !== undefined) {
            if (includeFirstItem && this._size > 0 && this._start > 0) { 
                this._start -= 1; 
            }
            this._size += amount || 0; 
        }
    };

    /* Move page forward to next page, or backwards to previous page */
    this.forward = function(newSize, max) {
        // max should be the size of the entire feed
        this._start = this.getEnd();
        if (newSize !== undefined) { this._size = newSize || 0; }
        if ((max !== undefined) && ((this._start + this._size) >= max)) {
            this._size = Math.max(0, max - this._start);
        }
        return this;
    };
    this.backward = function(newSize, max) {
        // max should be the size of the entire feed
        if (newSize !== undefined) { this._size = newSize || 0; }
        if (this._start - this._size >= 0) {
            this._start -= this._size;
        } else if (this._start > 0) {
            this._start = 0;
            if (max !== undefined) { this._size = Math.min(this._size, max); }
        } else { // this._start = 0
            this._size = 0;
        }
        return this;
    };

    /* Reset page to 0, 0 */
    this.reset = function() {
        this._start = 0;
        this._size = 0;
    };

    /* Mimic takes a page as an argument and sets the current page 
     * to "mimic" that page, i.e. have the same start and size */
    this.mimic = function(page, minSize) {
        minSize = minSize || 0;
        this.set(page._start, Math.max(page._size, minSize));
        return this;
    };

    /* Determines whether the arg page is consumed by the current page */
    this.consumes = function(page) {
        return (page.getStart() === this.getStart() && 
            page.getEnd() <= this.getEnd());
    };

    /* Determines whether this page contains the arg position or not */
    this.includes = function(pos) {
        return (pos >= this.getStart()) && (pos < (this.getStart()+this.getSize()));
    };

    /* Convenience methods for summarizing a page */
    this.asJson = function() {
        return {start: this.getStart(), size: this.getSize()};
    };
    this.asStr = function() {
        return 'start: '+this.getStart()+', size: '+this.getSize();
    };

    /* Returns whether the page is empty or not */
    this.isEmpty = function() { return this.getSize() === 0; };

    /* Split the page into subpages! */
    this.split = function(subPageSize) {

        /* This method splits a page into subpages */
        if (subPageSize <= 0) { return []; }
        var pos = this.getStart();
        var numPages = Math.ceil(this.getSize()/subPageSize);
        var subPages = [];
        var sp = null;
        for (var i=0; i<numPages; i++) {
            sp = new el8.uiwidget.FeedPage();
            sp.setStart(pos);
            sp.setSize(subPageSize);
            if (sp.getEnd() > this.getEnd()) {
                sp.setSize(this.getEnd() - sp.getStart());
            }
            subPages.push(sp);
            pos += sp.getSize();
        }

        return subPages;
    };
};

